import { transliterate as tr } from 'transliteration';

export function loc(obj, vars, lang) {
    vars = vars || {};

    if(lang === undefined) {
        lang = document.domain.indexOf('en.') === -1 ? 'ru' : 'en';
    }

    if(typeof obj === 'string' || obj instanceof String) {
        if(lang === 'en') {
            return tr(obj);
        } else
        {
            return obj;
        }
    }

    var string = obj[lang] || '';

    for(let key in vars) {
        string = string.replace('{' + key + '}', vars[key]);
    }

    return string
}

export function lang() {
    return document.domain.indexOf('en.') === -1 ? 'ru' : 'en';
}

export function locArgs(ru, en, vars, lang) {
    return loc({ru, en}, vars, lang);
}